import React, { useState, useEffect } from 'react'
import { http } from '@ud/admin-framework'
import './JobsList.less'
import classNames from 'classnames'
import { Spin } from 'antd'

const JobsList: React.FC<IJobsListProps> = (props) => {
  const [list, setList] = useState<any[]>([])
  const [querying, setQuerying] = useState<boolean>(false)
  const [currentKey, setCurrentKey] = useState<string>('')

  const getList = () => {
    setQuerying(true)
    http.post('/manage/org/query/orgPost', {}).then((res) => {
      setList(res.data.content)
    }).finally(() => {
      setQuerying(false)
    })
  }

  const selectJob = (v: any) => {
    props.selectJob && props.selectJob(v)
    setCurrentKey(v)
  }

  useEffect(() => {
    getList()
  }, [])

  return (
    <div className="jobs-list">
      <Spin size="small" spinning={querying}>
        <ul className="list">
          {list.map((v) => {
            return (
              <li key={v.uid} onClick={() => selectJob(v.uid)} className={classNames('item', { 'active': currentKey == v.uid })}>
                {v.name}
              </li>
            )
          })}
        </ul>
      </Spin>

    </div >
  )
}

interface IJobsListProps {
  selectJob?: any
}

export default JobsList
